import React from 'react'
import './index.scss'
import { Row, Col, Layout, Table, Button, Input, message, Modal, Tabs, Tag, Pagination } from 'antd'
import { ExclamationCircleOutlined, FileAddOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import AddModal from './modals/add'
import EditModal from './modals/edit'
import { connect } from 'react-redux'
import { loadReservation, deleteReservation, approveReservation, loadSelectedRowReservation } from '../actions'
import { getParamFromUrl } from '../../../../utilities/helper'
import moment from 'moment'
import Papa from 'papaparse'
import { getUser } from '../../../../utilities/token'
import {
  APPROVAL,
  APPROVED,
  CANCELLED,
  REJECTED
} from '../../../../utilities/serviceStatusEnum'
const { Search } = Input;
const { TabPane } = Tabs;
class Reservations extends React.Component {
  constructor() {
    super()
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      reservationStatus: '0',

      //pagination
      page: 1,
      limit: 10,
      searchTerm: '',

      selectedRow: {},
      selectedRowKeys: [],
      downloadLoading: false,
      tableData: []
    }
    this.addModalToggle = this.addModalToggle.bind(this)
    this.editModalToggle = this.editModalToggle.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { limit, searchTerm, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }

    if ((this.props.reservationSuccess !== nextProps.reservationSuccess) && nextProps.reservationSuccess) {
      this.setState({ isAddModalOpen: false })
      message.success("Reservation added successfully.")
      this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)
    }
    if ((this.props.updateReservationSuccess !== nextProps.updateReservationSuccess) && nextProps.updateReservationSuccess) {
      this.setState({ isEditModalOpen: false })
      message.success("Reservation edited successfully.")
      this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)
    }
    if ((this.props.deleteReservationSuccess !== nextProps.deleteReservationSuccess) && nextProps.deleteReservationSuccess) {
      this.setState({ isEditModalOpen: false })
      message.success("Reservation deleted successfully.")
      this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)
    }
    if ((this.props.approveReservationSuccess !== nextProps.approveReservationSuccess) && nextProps.approveReservationSuccess) {
      this.setState({ isEditModalOpen: false })
      message.success("Reservation approved successfully.")
      this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)
    }
    if ((this.props.reservationsSuccess !== nextProps.reservationsSuccess) && nextProps.reservationsSuccess) {
      this.setState({ tableData: nextProps.reservationsData.data })
    }
  }


  componentDidMount() {
    const { limit, searchTerm, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }

    this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)

    if (getParamFromUrl('modal') === 'true') {
      this.setState({ isEditModalOpen: true })
    }

    window.Echo.channel(`admin-reservations-crud.${getUser().id}`)
      .listen('.admin-reservations-crud-channel', (response) => {
        const { data } = response
        const index = this.state.tableData.findIndex(item => item.id === data.id)
        if (data.status === 0) {
          this.state.tableData.splice(index, 1) // delete
        } else {
          if (index !== -1) this.state.tableData[index] = data // update
          else {
            this.state.tableData.unshift({ ...data }) // create
            this.state.tableData = this.state.tableData.slice(0, this.state.limit) // re-assigning and limit to 10
          }
        }
        // this.setState({tableData: this.state.tableData})
        // this.setState are not working inside echo channel, 
        // regarding to this. <Table key/> key must be unique to know if there was a changed.
        this.forceUpdate()
      })
  }

  getKeyConvertToStatus(key) {
    let status
    switch (key) {
      case '0':
        status = ''
        break;
      case '1':
        status = APPROVAL
        break;
      case '2':
        status = APPROVED
        break;
      case '3':
        status = CANCELLED
        break;
      case '4':
        status = REJECTED
        break;
      default:
        break;
    }
    return status
  }
  onChangePagination(page, limit) {
    const { searchTerm } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }
    this.props.onLoadReservation(this.getKeyConvertToStatus(this.state.reservationStatus), pagination)

    this.setState({ page, limit })
  }

  addModalToggle() {
    this.setState({ isAddModalOpen: !this.state.isAddModalOpen })
  }

  editModalToggle() {
    this.setState({ isEditModalOpen: !this.state.isEditModalOpen })
  }

  handleDeleteReservation(id) {
    const self = this
    Modal.confirm({
      title: 'Do you want to delete this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'You cannot undo this.',
      onOk() {
        self.props.onDeleteReservation(id, self.getReservationStatus(self.state.reservationStatus))
      },
      onCancel() { },
    });
  }

  handleApproveReservation(id) {
    const self = this
    Modal.confirm({
      title: 'Do you want to reserve this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'You cannot undo this.',
      onOk() {
        self.props.onApproveReservation(id, self.getReservationStatus(self.state.reservationStatus))
      },
      onCancel() { },
    });
  }

  handleSearch(searchTerm) {
    const { limit, page } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.props.onLoadReservation(this.getReservationStatus(this.state.reservationStatus), pagination)

    }, 1000);
    this.setState({ searchTerm: searchTerm })
  }

  getReservationStatus(e) {
    let type
    switch (e) {
      case '0':
        type = ''
        break;
      case '1':
        type = 'approval'
        break;
      case '2':
        type = 'reserved'
        break;
      case '3':
        type = 'cancelled'
        break;
      case '4':
        type = 'rejected'
        break;
      default:
        break;
    }
    return type
  }

  getStatus(status) {
    switch (status) {
      case 1:
        return <Tag color="gold">FOR APPROVAL</Tag>
      case 2:
        return <Tag color="lime">APPROVED</Tag>
      case 3:
        return <Tag color="geekblue">ONGOING</Tag>
      case 4:
        return <Tag color="green">COMPLETED</Tag>
      case 5:
        return <Tag color="magenta">CANCELLED</Tag>
      case 6:
        return <Tag color="red">REJECTED</Tag>
      default:
        break;
    }
  }

  handleReservationStatus(e) {
    const { limit, page, searchTerm } = this.state
    const pagination = {
      page: page,
      limit: limit,
      searchTerm: searchTerm
    }
    this.setState({ reservationStatus: e.toString() })
    this.props.onLoadReservation(this.getKeyConvertToStatus(e), pagination)
  }

  countdownRenderer(props) {
    const { days, hours, minutes, seconds, completed } = props
    if (completed) {
      // Render a completed state
      return <div >
        <span style={{ fontWeight: 'bold', color: 'gray' }} >{moment(props.props.originalValue).format("LLLL")}</span><br />
        <span style={{ color: '#ff695e', fontWeight: 'bold', }}>(Expired)</span>
      </div>;
    } else {
      // Render a countdown
      return <span style={{ fontWeight: 'bold', color: '#1890FF' }}>{days}Days {hours}:{minutes}:{seconds}</span>;
    }
  };

  handleDownloadSelectedRowToCSV() {
    this.setState({ downloadLoading: true })
    this.props.onLoadSelectedRowReservation(this.state.selectedRowKeys).then(res => {

      const newData = res.payload.map(data => {
        return {
          id: data.id,
          ticketNumber: data.ticketNumber,
          clientCode: data.tenant && data.tenant.clientCode,
          clientName: data.tenant && data.tenant.uoccname,
          title: data.title,
          description: data.description,
          amenity: data.amenity && data.amenity.title,
          estimatedAmount: data.estimatedAmount,
          status: this.getStatusForCsv(data.status),
          remarks: data.remarks,
          startTime: moment(data.startTime).format('DD/MM/YYYY'),
          endTime: moment(data.endTime).format('DD/MM/YYYY'),
          completedDate: moment(data.completedDate).format('DD/MM/YYYY'),
          createdAt: moment(data.created_at).format('DD/MM/YYYY'),
        }
      })
      var csv = Papa.unparse(newData);

      var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, 'Reservation Reports.csv');
      }
      else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', 'Reservation Reports.csv');
      tempLink.click();

    }).finally(() => {
      this.setState({ downloadLoading: false })
    })
  }

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  getStatusForCsv(status) {
    switch (status) {
      case 1:
        return 'FOR APPROVAL'
      case 2:
        return 'APPROVED'
      case 3:
        return 'ONGOING'
      case 4:
        return 'COMPLETED'
      case 5:
        return 'CANCELLED'
      case 6:
        return 'REJECTED'
      default:
        break;
    }
  }

  access(title, role) {
    if (this.props.adminData.roles.length === 0) return false
    const found = this.props.adminData.roles.find(data => data.title === title)
    if (found !== -1) return (found.roles[role]) ? true : false
    else return false
  }

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      preserveSelectedRowKeys: true
    };
    const dataSource = this.state.tableData
    const columns = [
      {
        title: 'Service Ticket #',
        dataIndex: 'ticketNumber',
        key: 'ticketNumber',
        sorter: (a, b) => a.ticketNumber && a.ticketNumber.localeCompare(b.ticketNumber)
      },
      {
        title: 'Client Code',
        dataIndex: 'tenant',
        key: 'clientCode',
        sorter: (a, b) => a.tenant.clientCode && a.tenant.clientCode.localeCompare(b.tenant && b.tenant.clientCode),
        render: (info, data) => {
          return (
            <span>{data.tenant && `${data.tenant.clientCode}`}</span>
          )
        }
      },
      {
        title: 'Client Name',
        dataIndex: 'tenant',
        key: 'tenant',
        sorter: (a, b) => a.tenant.uoccname && a.tenant.uoccname.localeCompare(b.tenant && b.tenant.uoccname),
        render: (info, data) => {
          return (
            <span>{data.tenant && `${data.tenant.uoccname}`}</span>
          )
        }
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        sorter: (a, b) => a.title && a.title.localeCompare(b.title),

      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: (a, b) => a.description && a.description.localeCompare(b.description),

      },
      {
        title: 'Amenity',
        dataIndex: 'amenity',
        key: 'amenity',
        sorter: (a, b) => a.title && a.title.localeCompare(b.title),

        render: (item) => {
          return (
            <span className='init-capital'>{item && (item.title)}</span>
          )
        }
      },
      {
        title: 'Date Of Use',
        dataIndex: 'startTime',
        key: 'startTime',
        sorter: (a, b) => new Date(b.startTime) - new Date(a.startTime),
        render: (item) => {
          return (
            <span>{moment(item).format('LLLL')}</span>
          )
        }
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (item) => {
          return (<span>{this.getStatus(item)}</span>)
        }
      },
      {
        title: 'Actions',
        dataIndex: 'status',
        key: 'status',
        render: (item, data) => {
          switch (item) {
            case 1:
              return (
                <div className='action-btn'>
                  {
                    this.access('reservations', 'view') &&
                    <Button type="primary" icon={<EyeOutlined />} size={'medium'} title='View' onClick={() => this.setState({ selectedRow: data, isEditModalOpen: true, isModalEditEditable: false })} >View</Button>
                  }
                  {
                    this.access('reservations', 'reject') &&
                    <Button type="primary" icon={<DeleteOutlined />} size={'medium'} title='Delete' danger onClick={() => this.handleDeleteReservation(data.id)} >Delete</Button>
                  }
                </div>
              )
            case 2:
              return <div className='action-btn'>
                {
                  this.access('reservations', 'view') &&
                  <Button type="primary" icon={<EyeOutlined />} size={'medium'} title='View' onClick={() => this.setState({ selectedRow: data, isEditModalOpen: true, isModalEditEditable: false })} >View</Button>
                }
              </div>
            case 3:
              return <div className='action-btn'>
                {
                  this.access('reservations', 'view') &&
                  <Button type="primary" icon={<EyeOutlined />} size={'medium'} title='View' onClick={() => this.setState({ selectedRow: data, isEditModalOpen: true, isModalEditEditable: false })} >View</Button>
                }
              </div>
            case 4:
              return <div className='action-btn'>
                {
                  this.access('reservations', 'view') &&
                  <Button type="primary" icon={<EyeOutlined />} size={'medium'} title='View' onClick={() => this.setState({ selectedRow: data, isEditModalOpen: true, isModalEditEditable: false })} >View</Button>
                }
              </div>
            default:
              break;
          }
        }
      },
    ];
    return (
      <Layout className='reservations-container'>

        <Layout.Content>
          <div className='reservation-title'>
            <h1>Reservations</h1>
          </div>
          <Tabs defaultActiveKey="0" type="card" size='small' onChange={e => this.handleReservationStatus(e)}>
            <TabPane tab="All" key="0" />
            <TabPane tab="Approval" key="1" />
            <TabPane tab="Reserved" key="2" />
            <TabPane tab="Cancelled" key="3" />
            <TabPane tab="Rejected" key="4" />
          </Tabs>
          <Row>
            <Col md={14} lg={14} sm={24} xs={24}>
              <div className='mt3 mb3'>
                <Button type='primary' onClick={() => this.handleDownloadSelectedRowToCSV()} loading={this.state.downloadLoading}>Download CSV</Button>
              </div>
            </Col>
          </Row>
          <Row className='reservation-header'>
            <Col md={14} lg={14} sm={24} >
              <div className='action-btn'>
                {
                  this.access('reservations', 'add') &&
                  <Button type="primary" shape="circle" icon={<FileAddOutlined />} size={'large'} title='Add' onClick={() => this.addModalToggle()} />
                }
              </div>
            </Col>
            <Col md={10} lg={10} sm={24} className='input-search'>
              <Search placeholder="Search Title, Description, Comment Etc..." className='search' onChange={(e) => this.handleSearch(e.target.value, ['title', 'description', 'comment', 'amenity', 'status'])} style={{ width: 400 }} />
            </Col>
          </Row>
          <Row>
            <Table
              rowSelection={rowSelection}
              style={{ width: '100%' }} rowKey='id'
              key={(JSON.stringify(this.state.tableData))}
              loading={this.props.reservationsLoading || this.props.deleteReservationLoading} dataSource={dataSource} columns={columns} pagination={false} />
            <Row style={{ marginTop: 30, width: '100%' }}>
              <Col md={24} lg={24} sm={24} xs={24} align="right">
                <Pagination defaultCurrent={this.state.page} onChange={(page, limit) => this.onChangePagination(page, limit)} total={this.props.reservationsData.total} />
              </Col>
            </Row>
          </Row>
        </Layout.Content>
        {
          this.state.isAddModalOpen &&
          <AddModal
            visible={this.state.isAddModalOpen}
            reservationStatus={this.getReservationStatus(this.state.reservationStatus)}
            onCancel={this.addModalToggle}
          />
        }
        {
          this.state.isEditModalOpen &&
          <EditModal
            visible={this.state.isEditModalOpen}
            reservationStatus={this.getReservationStatus(this.state.reservationStatus)}
            selectedRow={this.state.selectedRow}
            onCancel={this.editModalToggle}
          />
        }
      </Layout>
    )
  }
}


function mapStateToProps(state) {
  return {
    reservationLoading: state.admin.reservation.reservationLoading,
    reservationSuccess: state.admin.reservation.reservationSuccess,
    updateReservationSuccess: state.admin.reservation.updateReservationSuccess,
    deleteReservationSuccess: state.admin.reservation.deleteReservationSuccess,
    reservationsSuccess: state.admin.reservation.reservationsSuccess,
    reservationsData: state.admin.reservation.reservationsData,
    reservationsLoading: state.admin.reservation.reservationsLoading,
    deleteReservationLoading: state.admin.reservation.deleteReservationLoading,
    approveReservationLoading: state.admin.reservation.approveReservationLoading,
    approveReservationSuccess: state.admin.reservation.approveReservationSuccess,
    adminData: state.admin.utilities.adminData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadReservation: (status, pagination) => dispatch(loadReservation(status, pagination)),
    onDeleteReservation: (id, status) => dispatch(deleteReservation(id, status)),
    onApproveReservation: (id, status) => dispatch(approveReservation(id, status)),
    onLoadSelectedRowReservation: (selectedKeys) => dispatch(loadSelectedRowReservation(selectedKeys))
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Reservations))
